/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import LogoutSvg from '../../assets/svgs/Logout';
import logout from '../../actions/Logout/logoutActions';

const Logout = ({ className }) => {
    const dispatch = useDispatch();

    const onClickHandler = () => {
        if (window.confirm('آیا مطمئن هستید؟')) {
            dispatch(logout());
        }
    };

    return (
        <div className={className} onClick={onClickHandler}>
            <LogoutSvg />
            <span>خروج از حساب کاربری</span>
        </div>
    );
};

Logout.propTypes = {
    className: PropTypes.string.isRequired
};
export default styled(Logout)`
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    border-radius: 5px;
    box-shadow: 0 3px 10px #e8ebff;
    margin-bottom: 12px;
    padding: 13px 25px 13px 33px;
    cursor: pointer;

    > span {
        font-size: 14px;
        font-weight: bold;
        line-height: 25px;
        color: #0d1fa1;
    }

    > svg {
        margin-right: -10px;
        margin-left: 13px;
    }
`;
